// extracted by mini-css-extract-plugin
export var content = "_e4-3";
export var list = "_e4-4";
export var settingsContent = "_e4-7";
export var settingsPanel = "_e4-8";
export var state = "_e4-6";
export var triggerBadge = "_e4-2";
export var triggerButton = "_e4-1";
export var triggerShell = "_e4-0";
export var unreadDot = "_e4-5";